import { useState } from "react";
import emailjs from "@emailjs/browser";
import React from "react";
import { motion } from "framer-motion";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const initialState = {
  name: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
};
export const Contact = (props) => {
  const [{ name, email, phone, subject, message }, setState] = useState(initialState);
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  const clearState = () => setState({ ...initialState });
  
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Set loading state
    setIsLoading(true);
    
    // Replace these with your EmailJS credentials:
    // 1. Go to https://dashboard.emailjs.com/admin
    // 2. Get your Service ID from Email Services
    // 3. Get your Template ID from Email Templates
    // 4. Get your Public Key from Account > General
    
    const serviceId = "service_info";  // e.g., "service_abc1234"
    const templateId = "template_71ewxlx"; // e.g., "template_xyz5678"
    const publicKey = "UjkA56l6fxhY8L3QB";   // e.g., "abcdefghijk12345"

    // Prepare template parameters
    const templateParams = {
      from_name: name,
      from_email: email,
      from_phone: phone,
      subject: subject,
      message: message,
     // to_email: "info@transwaveshipping.com" // Your email to receive messages
    };
    
    // Send email using EmailJS
    emailjs
      .send(serviceId, templateId, templateParams, publicKey)
      .then(
        (result) => {
          console.log("Success:", result.text);
          toast.success("Thank you! Your message has been sent successfully. We'll get back to you soon.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          clearState();
          setIsLoading(false);
        },
        (error) => {
          console.log("Error:", error.text);
          toast.error("Oops! Something went wrong. Please try again or contact us directly via phone/email.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setIsLoading(false);
        }
      );
  };
  return (
    <div>
      <ToastContainer />
      <motion.div
        id="contact"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.6 }}
      >
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <motion.div
                className="section-title"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
              >
                <h2>Get In Touch</h2>
                <p>
                  Fill out the form below and we'll get back to you as soon as possible.
                </p>
              </motion.div>
              <motion.form
                name="sentMessage"
                validate
                onSubmit={handleSubmit}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.1 }}
              >
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        value={name}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        value={email}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        className="form-control"
                        placeholder="Contact Number"
                        required
                        value={phone}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        className="form-control"
                        placeholder="Subject"
                        required
                        value={subject}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    value={message}
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button 
                  type="submit" 
                  className="btn btn-custom btn-lg" 
                  disabled={isLoading}
                  style={{ position: 'relative', minWidth: '170px' }}
                >
                  {isLoading ? (
                    <>
                      <span style={{ opacity: 0.7 }}>Sending</span>
                      <span className="loader" style={{
                        border: '2px solid #f3f3f3',
                        borderTop: '2px solid #fff',
                        borderRadius: '50%',
                        width: '16px',
                        height: '16px',
                        animation: 'spin 1s linear infinite',
                        display: 'inline-block',
                        marginLeft: '10px',
                        verticalAlign: 'middle'
                      }}></span>
                    </>
                  ) : (
                    'Send Message'
                  )}
                </button>
              </motion.form>
            </div>
          </div>
          <motion.div
            className="col-md-3 col-md-offset-1 contact-info"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                <a href={`tel:${props.data ? props.data.phone.replace(/\s/g,"") : ""}`}>
                  {props.data ? props.data.phone : "loading"}
                </a>
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                <a href={`mailto:${props.data ? props.data.email : ""}`}>
                  {props.data ? props.data.email : "loading"}
                </a>
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-clock-o"></i> Office Hours
                </span>{" "}
                {props.data ? props.data.officeHours : "Mon-Fri: 9AM-6PM"}
              </p>
            </div>
            {/* WhatsApp quick link */}
            <a
              href={props.data ? props.data.whatsapp : "https://wa.me/971504173911"}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whatsapp-contact"
            >
              <i className="fa fa-whatsapp"></i> Chat on WhatsApp
            </a>
          </motion.div>

          {/* Google Maps Embed */}
          <div className="col-md-12">
            <motion.div
              className="google-map-wrapper"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <iframe
                title="Transwave Shipping Location — Al Barsha 1, Dubai"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3613.6!2d55.1987!3d25.1124!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2sAl+Barsha+1%2C+Dubai+UAE!5e0!3m2!1sen!2sae!4v1"
                width="100%"
                height="320"
                style={{ border: 0, borderRadius: "8px", marginTop: "24px" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </motion.div>
          </div>

          {/* Social Follow Row */}
          <div className="col-md-12">
            <motion.div
              className="social"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <ul>
                <li>
                  <a href={props.data ? props.data.facebook : "/"} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                    <i className="fa fa-facebook"></i>
                  </a>
                </li>
                <li>
                  <a href={props.data ? props.data.instagram : "/"} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                    <i className="fa fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a href={props.data ? props.data.linkedin : "/"} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                    <i className="fa fa-linkedin"></i>
                  </a>
                </li>
                <li>
                  <a href={props.data ? props.data.whatsapp : "/"} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                    <i className="fa fa-whatsapp"></i>
                  </a>
                </li>
              </ul>
            </motion.div>
          </div>

        </div>
      </motion.div>

    </div>
  );
};
